import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        primary: {
            main: "#1E53A3"
        },
        secondary: {
            main: "#3A830F"
        }
    },
    typography: {
        fontFamily: ['Noto Sans JP', 'sans-serif'].join(',')
    },
    components: {
        MuiSelect: {
            styleOverrides: {           
                icon: {
                    color: "#1E53A3"
                }
            },
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    '&::before': {
                        borderBottom: "none"
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    padding: "0 10px",
                    height: "33px",
                    backgroundColor: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    color: "#333333",
                    border: "solid 1px #1E53A3",
                },
                notchedOutline: {
                    display: "none"
                },
                input: {
                    height: "33px",
                    padding: 0,
                }
            }
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    maxWidth: "100%"
                }
            }
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    width: "100%"
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                outlined: {
                    backgroundColor: "#fff"
                }
            }
        },
        MuiTablePagination: {
            styleOverrides: {
                input: {
                    marginRight: "8px"
                },
                selectIcon: {
                    color: "#6C6666"
                }
            }
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    padding: 0,
                    height: "100%"
                },
                input: {
                    padding: 0,
                    height: "100%"
                },
                inputRoot: {
                    padding: 0,
                    height: "100%"
                }
            }
        }
    },
})

export default theme;